import notifications from "./notifications";

const notificationService = [{
    matcher: 'notification',
    reply: config => {
        return [200, notifications]
    }
}]

export default notificationService